export const data = [
	[
		{
			id: 1,
			name: "김지형",
			major: "융콘·22",
			content: `[아무것도 모른 채로 멋사 들어간 사람이 있다?!]
			저는 정말 UX에 대해 아무것도 몰랐답니다. 기획 경험은 당연히 없는 데다, 저는 당시 2학년으로 콘텐츠아키텍처링 수업을 아직 듣기도 전이었어요. UX가 뭔지는 어렴풋이 알지만, 어떻게 만들어 내는 지에 대해서는 하나도 모르는 상태였죠.
			
			[기디 언니들의 UX 조기교육을 받다]
			이런 저에게 교수님보다 더 빨리 UX 기획을 알려준 건 11기 언니들이었습니다. 언니들과의 전공 강의 못지않은 퀄리티의 세션과 스터디를 거치며 어디 가서 UX 기획 과정에 대해 아는 척 할 수 있는 수준이 되었답니다^^
			
			[해커톤을 거듭하며 강해지다]
			사실 언니들 없는 해커톤은 겁이 나기도 했어요. 혼자서 기획과 디자인을 담당하고, 개발자들과의 소통과 전반적인 계획 수립도 전부 혼자 했어야했거든요. 하지만 전 조기 교육을 통해서 강하게 컸으니깐요..하하 굴하지 않고 혼자 해내는 경험을 거듭하면서 이젠 혼자서 해커톤 일을 맡아도 두렵지 않은 정도가 되었답니다.
			
			[막내에서 12기 운영진이 되다]
			멋사에서 정말 많은 성장을 한 저는 12기의 기디 운영진이 되었답니다. 멋사에서 이론과 실전, 전부 골고루 경험할 수 있었는데요. 이제는 12기 아기사자들과 만나면서 할 수 있는 경험들이 기대됩니다. 새로운 경험과 성장이 저를 기다리고 있겠죠? 그 누구든, 일단 모두 잘부탁드립니다😉`,
		},
		{
			id: 2,
			name: "손예원",
			major: "경영·20",
			content: `멋쟁이사자처럼에서 2학기 동안 활동하면서, 기획/디자인 파트로 참여하면서, 개인적으로 성장하는 경험을 할 수 있었습니다. 평소 만날 수 없었던 다양한 전공의 부원들과 혐력하며 프로젝트를 완성해나갈 수 있어서 뿌듯했습니다.
			기획파트에서는 기존의 관점 보다는 서비스 관점에서 아이디어를 도출하고 그것을 구체화 시키는 것을 통해 창의적인 사고의 중요성을 다시 느끼게 되었고, 같은 기획/디자인 부서 부원들에게 많이 배울 수 있는 시간이었던 것 같습니다. 프로젝트를 진행하면서도 기획파트의 유동적인 역할을 배울 수 있어서 좋았던 것 같습니다.
			디자인 파트에서는 사용자 경험을 고려해서 UX/UI를 제작하는 과정을 주로 맡았는데, 이렇게 UX/UI를 제작하는 것이 처음이다 보니 손도 느리고, 어떤 식으로 시작해야하는지 몰라서 많이 헤맸던 것 같습니다. 가장 아쉬운 부분이기도 하고, 힘들었던 부분이기도 한 것 같습니다. 실제 프로젝트가 시작하기 전에 조금 더 능력이 있었다면.. 하는 아쉬움이 있습니다.
			이러한 활동을 통해서 멋쟁이사자처럼에서 개인적인 역량을 향상시키고, 협업 능력을 키울 수 있었던 것 같습니다. 실제로 해커톤에 참여하고, 졸업 프로젝트를 진행하면서 문제 해결 능력이나 창의적 사고력을 발전시킬 수 있었던 것 같습니다. 마지막으로, 너무 다들 멋진 사람들이어서 제 능력이 부족하다는 생각을 매우 많이 했던 것 같습니다. 도움이 많이 못 되어서 너무 미안하고, 좋은 곳에서 다시 만날 수 있었으면 좋겠습니다.`,
		},
		{
			id: 3,
			name: "이시은",
			major: "디학·21",
			content: `멋사 처음에 시작할 때 두려움이 정말 컸었어요. 다른 이유가 아니라 지극히 개인적인 이유로요.. 아직 아무것도 모르는 내가 개발자분들과 감히 같이 프로젝트를 해도 되는 건가 싶고, 많이 무섭구 걱정되고 그랬었거든요. 하지만 이런 걱정이 무색하게도, 멋사에서 따~숩고(대박 따수움) 좋은 분들이랑 협업하구 프로젝트 진행할 수 있어서 너무 안심됐어요. 같이 서비스 만들어 나가다가 문제가 생기면 각자 할 일 하다가도 바로 곧장 달려와줘서 어떻게 해야 할 지 의논해주고, 노력해서 해결해보겠다고 해주는 순간들도 저한테는 하나하나 너무 영광스럽고 감격이었답니다. 이런 과정들이 저한테는 평생 못 잊을 순간이 될 거 같아요. 또! 항상 모르는 거 있을 때마다 부랴부랴 찾아가서 물어보면 친절하게 알려주구 도와줬던 운영진들도.. 11기가 이렇게 화목하구 아름다운 행태(?)로 운영될 수 있었던 이유는 운영진 분들의 노력이 컸기 때문이 아닌가 하는 생각이 드네요. 항상 너무 감사한 마음으로 도움을 받았던 것 같습니다. 마지막으로 우리 기획/디자인 파트! 다들 너무 대단하구, 같이 하면서 기획의 다양성, 깊이의 정도를 진짜 많이 배웠던 거 같아요. 이런 모자란 저라도 같이해주어서 감사하다는 말씀밖엔.. 나오질 않군요. 저에게 있어 새로운 인연들과 배움, 경험들을 할 수 있도록 해 준 11기 멋사, 정말 고마워요!`,
		},
		{
			id: 4,
			name: "이지민",
			major: "융콘·21",
			content: `“어떻게 이런 사람들만 모였지?” 싶을 만큼 11기 운영진, 아기 사자 모두 너무 좋은 사람들을 만나 정말 행복했습니다💚 논리적인 기획, 비즈니스 모델, 핸드오프 시스템, 반응형 디자인 등 지금은 다 너무 당연히 해야 하는 것들인데 다시 생각해 보면 사실 다 멋사에서 처음 배우고 적용해 나가며 터득한 것이라는 게 새삼스럽네요. 그만큼 1년 동안 누구보다 많이 배우고 성장한 것 같아 스스로가 대견하기도 하지만, 무엇보다 이런 저에게 열심히 알려주고 서로 배우면서 같이 열심히 활동해 준 11기 멋사 친구들에게 가장 고맙다는 말을 전하고 싶습니다🫶 정말 엄마(?) 마냥 1부터 100까지 다 미리 준비하고 챙겨주고 이끌어 준 운영진 친구들, 기획 및 디자인에 누구보다 공감해 주며 “안 된다”라는 말보다 “일단 해보겠다”, “할 수 있다”라고 얘기하면서 진짜 해내 준 멋진 프엔+백엔 친구들, 그리고 서로 의견 공유하고 같이 멋진 서비스 만들며 제가 가장 많이 배웠던 최고의 우리 장녀즈 기디 사자들까지.. 같이 멋사 해줘서 너무너무 고마워요!! 덕분에 이화에 들어오고 나서 가장 값진 1년을 보내고 갑니다:)`,
		},
		{
			id: 5,
			name: "이채원",
			major: "융콘·18",
			content: `문자 그대로 제 인생의 전환점이었던 멋사에서의 1년을 마무리하자니 만감이 교차하네요!🥹 그리고 즐거웠던 순간들이 머리를 스치고 지나갑니다. 먼저 알찼던 세션 시간과 근방의 카페를 부수면서 진행했던 스터디 시간이 생각나요. 덕분에 피그마와 디자인 시스템에 관한 내용을 신속히 익힐 수 있었습니다. 또 아이디어톤부터 여기톤, 중앙해커톤, 졸프까지 잊지 못할 프로젝트 과정도 떠올라요. 한 프로젝트에서 배웠던 점을 다음 프로젝트에 어떻게 적용해 볼까 고민을 많이 했는데, 이 과정에서 크게 성장할 수 있었다고 생각합니다. 무엇보다 이 모든 순간에 계셨던 소중한 분들이 기억에 남아요. 너무 애썼고 프로젝트에 더 큰 욕심을 갖게 해준 우리 프엔, 백엔 친구들! 진심으로 무한히 감사드립니다. 그리고 우리 기디! 국밥마냥 든든하고 멋있는 엄마사자 윤이, 그저 빛인 수민언니, 재능억만장자 재능만수르 시은이, 브레인이라는 말이 찰떡같이 어울리는 예원이, 섬세하고 열정적이어서 메이트로 하여금 최선의 디자인을 갈구하게 하는 최고 졸프메이트 지민이, 이런 말 해도 될지 모르겠는데 예뻐 죽겠는 최강막내 지형이까지... 여러분께 참 많은 자극을 받았고 의지했습니다. 우리 종종 오래 봐요. 살앙합니다. 마지막으로 스무스하고 전능한 운영을 보여준 운영진 여러분! 1년간 정말 정말 고생 많으셨고 감사하다고 말씀드리고 싶었어요. 함께할 수 있어서 영광이었고 정말 고마웠습니다! 서로의 미래에 성취와 행복과 건강이 있기를 바랄게요! 다들 또 만나요!!!💞`,
		},
		{
			id: 6,
			name: "임수민",
			major: "커미·18",
			content: `안녕하세요~! 멋사 11기 기획디자인으로 활동한 임수민입니다 🎨
			멋사에서 다양한 경험을 채우고 싶어서 처음 자기소개 노션의 이모지를 🎨로 선택했는데요! 1년이 지난 지금 돌아보니
			단순히 다양한 색깔을 모아둔 팔레트보다도 훨씬 입체적인, 평면이 아닌 ‘구’ 와 닮은 경험을 채워 가는 것 같습니다 🥰
			함께 활동하며 정말 다양한 것을 배었습니다. 기획만 할 줄 알던 제가 디자인에 대해 조금씩 이해할 수 있었고, 피그마 스킬도 얻어가고 💻 개발자와 협업하는 법을 배우고 👾 서비스 기획 자체도 더 깊이있게, 진짜 문제를 해결하기 위한 치열한 고민을 해볼 수 있었습니다.
			이렇게 풍성한 경험으로 멋사에서 1년동안 성장한 저에게 크게 두가지 아웃풋이 남았어요! ✨
			첫째, 오래전부터 목표로 하던 회사에 최종 합격을 했습니다.. (💚) 
			멋사에서 배운 것들을 실제로 전형 중에 써먹기도 했기 때문에 ! 저의 합격 일등 공신이라고 할 수 있겠습니다 ㅠ_ㅠ 다시한번 정말정말 감사합니다 🧡
			둘째, 멋지고 좋은 사람들이 가득 남았습니다 🫶🏻
			멋사에는 정말이지 본받을점 가득한 친구들밖에 없어요. 어딜 보나 긍정적인 영향력과 자극을 매 순간 잔뜩- 받는지라 스스로 끊임없이 발전하고 노력할 수 있었습니다. 
			이렇게 적고 나니 1년전 멋사 들어가겠다고 밤새 포폴 만들고, 자소서 쓰고, 면접 준비하던 제 자신이 기특해서 안아주고 싶을 지경... 🥹 
			이제는 여기서 배운걸 갖고 멋진 사회인이 되어볼게요! 다시한번 고마웠어요 멋사 최고! 🦁`,
		},
	],
	[
		{
			id: 1,
			name: "김가영",
			major: "융콘·21",
			content: `2023년을 멋사에서 보내며 짧은 시간 동안 정말 많이 배워가는 것 같습니다! 학과 프로젝트에서 기획과 디자인만 진행하다 보니 혼자서는 해소하기 힘들었던 개발에 대한 부족함을 멋사에서 많이 채울 수 있었고, 생각보다 개발 재밌네..?? 싶은 마음도 좀 들었던 것 같아요ㅎㅎ 물론 개발 과정에서 힘들었던 점이 없었다면 거짓말이지만, 11기 프엔 친구들과 운영진분들 덕분에 잘 극복해 나갈 수 있었다고 생각합니다! (늘 질문할 때마다 디코에 누구보다 빠르게 달려와 준 프엔 운영진들.. 너무 고마웠어요🥹) 멋사에서의 경험은 이전까지 기획과 디자인에서만 머무르던 저에게 개발 협업이 무엇인지, 어떻게 더 효율적으로 프로젝트를 진행할 수 있는지를 알게 해 준 소중한 시간이라고 할 수 있을 것 같아요:) 저와 멋사 생활을 함께 한 11기 아기사자들 모두 너무 고생했고, 특히 우리 프엔이들 너무 수고 많았어💚 앞으로도 자주 보자 우리!!`,
		},
		{
			id: 2,
			name: "변지혜",
			major: "사보·23",
			content: `멋사는 짱이에요..👍 멋사에서 활동한 9개월 덕에 정말 많이 성장할 수 있었습니다. 멋사에 들어와 웹 개발을 시작했는데 이제는 졸업 프로젝트를 만들 수 있게 되었네요. 점점 프론트에 욕심을 내게 되고•• 더 넓은 곳을 바라볼 수 있게 해준 이멋 !! 해커톤처럼 협업할 기회가 많았던 것이 큰 장점이라고 생각해요. 소통과 협업으로 프로젝트를 만들어나가는 과정에서 덕분에 많이 배웠습니다. 함께 팀을 했던 아기사자 뿐만 아니라 모든 아기사자&어른사자와 만날 수 있어서 정말 행복했어요🫶 정말 벌써 1년이 지났다는 게 너무 아쉬울 정도로🥲 함께 할 수 있어서 행운이었다는 말을 살포시 남겨봅니다.. 열정 가득한 사람들 사이에서 좋은 의미의 자극을 듬뿍 받아갈 수 있었어요!! 매주 있었던 과제에서 시작해 크고 작은 프로젝트까지, 멋사의 모든 활동에서 이대 멋사와 함께 할 수 있어서 진심으로 행복했습니다. 더불어 항상 응원과 조언을 아끼지 않아준 운영진분들 덕분에 마음이 정말 든든했어요🥹 멋사가 아니었다면 올 한 해가 어땠을지 상상도 되지 않을 만큼, 저에게 많은 행운과 행복을 안겨준 동아리였습니다🦁`,
		},
		{
			id: 3,
			name: "유서연",
			major: "컴공·22",
			content: `벌써 멋쟁이사자처럼 11기 활동이 끝났다니.. 시원섭섭이 아니라 섭섭함만 가득할 정도로 보내기 아쉬운 시간들이었습니다. 멋사에 들어오기 전까지만 해도 웹 개발에 대해서 아무 것도 몰랐었는데, 멋사와 멋사 운영진분들 덕분에 기초부터 시작해 하나의 웹사이트를 배포할 수 있는 수준까지 단계적으로 잘 성장할 수 있었어요! 다양한 해커톤에도 나가보고 멋있고 훌륭한 우리 아기사자들과 여러 프로젝트를 함께하며 협업할 수 있어서 저에게는 과분한 시간들이었습니다. 멋사에서 너무 좋은 사람들을 만나고 소중한 경험을 쌓은 것 같아 정말 행운이라고 생각해요:)! 특히 운영진분들께 큰 감사의 말씀을 드립니다.. 너무 고생하셨어요🥺🙇‍♀️ 11기 활동은 끝이 났지만 저는 언제 어디서든 항상 우리 11기를 응원하고 있을 겁니다. 감사했고 사랑합니다. 멋사 짱🧡`,
		},
		{
			id: 4,
			name: "이다빈",
			major: "컴공·20",
			content: `멋사에 합격 후 떨리는 마음으로 OT에 참석한 지 얼마 안 된 것 같은데 벌써 일 년의 기수를 마무리할 때가 되었네요! 멋사가 아니었다면 경험할 수 없었을 큰 규모의 해커톤도 참여해 보고, 다른 학교의 사람들과 협업하여 프로젝트를 진행할 기회도 있어 좋았습니다. 학교를 다니면서 본격적으로 프로젝트를 개발해 본 경험이 없었는데 멋사에서 다양한 활동을 하며 프로젝트의 기획부터 배포까지의 과정을 겪어보고 그 과정에서 발생하는 여러 오류들을 해결해나가며 더 많이 배울 수 있었습니다.
			그리고 무엇보다 멋사에 들어와서 소중한 인연들을 만날 수 있어 감사했습니다.
			매 세션마다 꼼꼼하고 열정적으로 이끌어주고 문제가 생기면 언제든 편하게 불러달라는 운영진분들, 함께 으쌰으쌰 하며 배우고 성장할 수 있었던 프엔 아기사자들에게 감사의 말 전합니다. 열정과 노력으로 무엇이든 최선을 다해 매듭지으려는 모습에 매번 자극받고 배울 점이 많다고 느꼈습니다.
			멋사에 처음 지원할 때 멋사에서의 활동이 대학 생활의 크고 소중한 부분이 되길 바란다고 했는데 그 바램을 이룬 것 같아 뿌듯합니다. 1년동안 다들 고생많았습니다🦁🧡`,
		},
		{
			id: 5,
			name: "진규빈",
			major: "호크마·23",
			content: `입학한 지 딱 일주일 되던 날 멋사 면접을 본 기억이 납니다. 새내기였던 제게 개발동아리 지원은 엄청난 도전이었습니다. 그때의 무모함 혹은 용기 덕분에 2023년 한 해를 참 알차게 보낼 수 있었다고 생각합니다. 코딩 노베였기에 초반에는 걱정이 정말 많았습니다. 과제를 할 때 시간이 오래 걸리거나 오류가 지속되면 답답하고 괴롭기도 했습니다. 하지만 점차 발전하는 스스로를 보며 뿌듯함이 커졌고, 이는 더 열심히 활동하고자 하는 자극제가 되었습니다. 자칫하면 아무 배움 없이 흘러갈 수도 있었던 1학년, 멋사 덕분에 짧은 시간 동안 웹 개발에 친숙해진 것 같습니다. 다양한 스터디, 해커톤, 프로젝트를 통해 협업 과정을 몸소 겪은 것은 물론, 한 가지 작업에 완전히 몰두하는 값진 경험을 할 수 있었습니다. 그리고 멋사에서 만난 소중한 인연들 덕분에 진심으로 행복했습니다:) 이토록 열정 가득한 사람들과 교류하면서 많이 배웠고, 운영진분들의 도움과 체계적인 커리큘럼으로 한 층 더 성장한 제가 될 수 있었습니다. 앞으로의 로드맵을 그려나가는 데 가이드라인이 되어준 멋사, 고맙고 사랑합니다-!`,
		},
		{
			id: 6,
			name: "최지원",
			major: "컴공·22",
			content: `11기 아기사자로 보낸 지난 1년은 저에게 그 어떤 경험보다 값지고 빛난 소중한 시간이었습니다. 처음에는 아무것도 모르는 채로 시작했지만 한 학기동안 배워나간 세션, 그리고 바로 실전에 투입되었던 방학동안 세 번의 해커톤을 거치면서 짧은 시간에 이렇게나 성장할 수 있나 싶을 정도로 많은 것을 얻어갔습니다. 혼자서는 해보지 못할 협업의 경험을 다른 학교의 다양한 사람들과 만나 경험해보기도 하였고, 특히 우리 학교 아기사자들과의 협업은 그저 행복이자 행운이었습니다..🍀 이렇게나 열정 넘치고, 배려 가득하고, 뛰어난 부원들과 한마음 한뜻으로 프로젝트에 진심을 다해 협업할 수 있다는 사실만으로도 너무나 감사했고, 그런 모습들에 힘입어 저 역시 더 큰 책임감을 가지고 최선을 다해 임하게 되었던 것 같습니다. 이런 성장을 이끌어준 운영진분들, 너무 고생 많으셨고 프엔 질문도 언제나 환영해주셔서 정말 감사했습니다ㅎㅎ 천재들만 모인 존경스러운 기디, 무엇이든 척척 해내어 든든한 백엔드, 그리고 매번 도전을 함께한 우리 프론트엔드 모두 고생했고 고마웠어요! 개발 실력만 얻게 된 것이 아니라 좋은 사람들과 함께 했기에 더욱 성장하는 1년이 아니었나 싶습니다. 열심히 한 만큼 배워갈 기회가 된 덕분에 이제는 어엿한 어른사자로 거듭나게 해준 멋사에 다시 한 번 감사합니다🦁`,
		},
	],
	[
		{
			id: 1,
			name: "김지은",
			major: "영교·21",
			content: `멋사는 2023년 제 성장의 큰 부분을 차지했습니다:) 각자의 분야에서 최선을 다해 최고의 결과물을 보여주는 멋쟁이 사자들 덕분에 저도 원동력을 얻고 많은 걸 배울 수 있는 한 해 였던거 같습니다! 설레는 마음으로 공대에서 오티에 참석했던게 얼마 안 된 일 같은데 벌써 멋사를 떠날 시기가 가까워졌다는게 아쉽습니다.. 3월 첫 세션 때에 개발의 세계에 가졌던 막연한 두려움이 더 열심히 공부해 멋있는 개발자가 될 미래에 대한 설렘으로 바뀌게 된건 전부 멋사 덕분입니다! 막 활동을 시작할 때에만 해도 과연 내가 프로젝트를 만들어낼 수 있을까 확신이 없었는데, 도움과 에너지를 잔뜩 준 백엔드 아기사자, 운영진 어른사자들 덕분에 많이 성장할 수 있었던 것 같습니다! 그리고 프론트엔드, 기획디자인 사자들과 함께하면서 협업 시에 소통하는법을 많이 배우고 백엔드로서 고려해야 할 것들에 대한 시야를 넓힐 수 있었습니다! 중앙해커톤, 신촌톤, 대동제 리팩토링 그리고 졸업프로젝트를 거치며 함께한 모든 팀원들에게 감사의 인사를 전합니다♡ 정말 코딩의 ㅋ만 겨우 알던 제가 터미널에 명령어를 자연스럽게 치고 있을 때면 기초부터 천천히 알려준 운영진 어른 사자 친구들에게 너무너무 고마운 마음이 듭니다..ㅎㅎ 열정 넘치는 아기사자 어른사자들 덕분에 저도 더 큰 꿈을 꾸는 사람이 되었습니다! 멋사와 함께 이뤄낸 결과물들이 앞으로 제가 더 나은 개발자로 성장하는 데에 있어 든든한 기반이 되어 줄 거라고 확신합니다. 그리고 모든 사자들의 따뜻한 에너지 덕분에 11기 활동 내내 정말 행복했습니다ㅎㅎ 세션도, 회식도, 프로젝트도, 엠티도 항상 긍정적인 에너지를 많이 얻어가는 시간들이었습니다!! 특히 백엔드 스터디 때에 돌아가면서 과자를 사와 나눠먹던 귀여운 추억들과 엠티에서 물놀이 하던 멋사의 낭만을 오래 기억하고 싶습니다..♡ 모두모두 1년 동안 정말 감사했습니다 앞으로도 뭐든지 킵고잉 파이팅!!!`,
		},
		{
			id: 2,
			name: "박나담",
			major: "컴공·22",
			content: `이대 멋사에서 1년동안 활동할 수 있어서 정말 행복했습니다. 이대 멋사는 저에게 정말 정말 너무 큰 존재예요. 제가 이화 들어와서 가장 잘했던 일이 멋사를 들어온 일입니다.
			이대 멋사에서 정말 많은 것을 배웠습니다. 사실 처음에 백엔드와 프론트엔드도 정확히 구분하지 못했는데, 이제는 프로젝트를 할 수 있는 정도까지 성장했습니다. 하지만 무엇보다 저는 이대 멋사의 어른 사자나 아기 사자들을 보면서 참 많이 배웠습니다. 다들 정말 바쁘게 살면서도 더 발전하기 위해 많은 일들을 성공적으로 끊임없이 해내는 모습이 큰 귀감이 되었습니다. 저는 그 모습들을 보면서 제 한계를 갱신하고 주어진 많은 일들을 성공적으로 해내려고 노력하면서 더욱 발전할 수 있었습니다. 그래서 모두에게 정말 감사하다는 말을 전하고 싶어요.
			비록 너무 아쉽게도 11기를 끝으로 이대 멋사를 떠나게 되었지만, 언제나 이대 멋사는 제게 소중한 존재로 남아있을 거예요. 다들 너무 고생했고, 사랑합니다!!! 이대 멋사 최고!!!`,
		},
		{
			id: 3,
			name: "심예원",
			major: "독문·22",
			content: `참 막연한 마음으로 지원서를 내고 긴장하던 것이 마치 엊그제 같은데 어느새 기수를 졸업하게 된다는 것이 감회가 정말 남다른 것 같습니다. 이화여대 멋쟁이사자처럼 11기 아기사자로 활동하며 1년간 정말 많은 것을 배우고 경험하였습니다! 개발은 차치하고 코딩도 할 줄 모르던 제가 운영진들과 부원들의 도움으로 해커톤도 참여하고 여러 프로젝트도 진행해 볼 수 있었습니다. 멋사가 아니었다면 절대 해 볼 수 없는 소중한 경험들이였어요! 비전공자로서 개발을 배우며, 새로운 분야를 배우는 즐거움을 느낄 수 있었고 기술적인 부분뿐만 아니라 협업하고 소통하는 방법도 배우며 성장할 수 있었습니다. 멋사에서의 배운 모든 것들이 앞으로 대학생활에 있어서 정말 소중한 자산이 될 것이라 생각해요! 이렇게 좋은 기회를 함께할 수 있게 도와준 11기 아기사자, 운영진 언니들에게 정말 감사합니다 ♥`,
		},
		{
			id: 4,
			name: "윤서아",
			major: "뇌인지·21",
			content: `멋사 덕에 충만한 2023년이었습니다! 의지만 가득하고 아무것도 모르는 상태로 들어와서 여러 프로젝트를 해나가다 보니 재밌었고, 어려웠고, 점점 뭔가를 알아가는 스스로가 신기하기도 하고 그랬네요. 모르는 게 생길 때마다 찡찡대며 물어보면 바로 답해준 어른 사자들, 함께 고민해준 11기 아기 사자들 덕분에 많이 배웠습니다. 단순히 개발뿐만 아니라 프로젝트와 협업을 대하는 자세, 열정 그런 심리적인 것들을 배운 것 같아서 마음이 꽉 차고 든든한 느낌이에요. 멋사를 통해 알게 된 소중한 인연들은 말할 것도 없고요 ~ 이화에서 한 여러 가지 것들 중에 멋사는 절대 잊을 수 없는 추억이 될 것 같아요. 그동안 감사했습니다 ♥`,
		},
		{
			id: 5,
			name: "이지원",
			major: "컴공·21",
			content: `멋사에 붙고 싶다는 간절함에 덜덜 떨며 면접을 봤던 게 엊그제 같은데 벌써 끝이 난다니 많이 아쉬워요. 멋사에 들어와서 학교 수업만으로는 얻을 수 없는 값진 경험들을 많이 할 수 있었어요.
			대략적으로만 알고 있던 프론트엔드와 백엔드의 차이가 무엇인지를 협업하며 직접 느꼈습니다. 백엔드 세션을 통해 장고, drf, api, aws 배포 등을 배웠고, 여러 해커톤에 참여하며 기획 디자인, 프론트 엔드, 백엔드가 어떻게 협업하는지, 어떤 과정으로 하나의 웹 서비스가 만들어지는지 알게 되었습니다. 또 멋사에서 활동하며 어떤 게 부족하고, 앞으로는 어떤 공부를 해야 하는지도 알게 되었습니다.
			이렇게 성장하기까지 가장 큰 도움이 되어 준 운영진분들 너무 고마워요.
			여러 대회와 행사를 준비해 주고, 오류 나면 척척 해결해 주고, 세션 때도 너무 잘 가르쳐 주었던 운영진분들 덕분에 어려워도 포기하지 않고 열심히 할 수 있었어요.
			또 언제나 열심히 배우고 쑥쑥 실력을 키워가는 아기사자들을 보며 저도 자극을 많이 받았어요.
			특히 시행착오를 함께 겪으며 동고동락한 백엔 아기사자들! 개발 중에 헤맬 때 같이 오류 찾아주고 도와줘서 고마워요. 덕분에 모든 스터디가 즐겁고 재밌었어요! 열정 넘치고 능동적인 친구들이 모여 함께 공부하고, 머리를 맞대며 고민하고, 협업할 수 있어서 행복했어요.
			엠티도 가고 회식도 하며 기디, 프엔, 백엔분들 다 같이 좋은 추억과 인연을 쌓을 수 있어서 너무 좋았어요.
			모두들 1년 동안 정말 감사했습니다~!!`,
		},
		{
			id: 6,
			name: "이혜지",
			major: "경영·20",
			content: `멋쟁이사자처럼 11기 아기사자로 선발되었다는 문자를 받고 기뻐했던 때가 얼마 전 같은데, 벌써 졸업 프로젝트만을 남겨두고 있다는 사실이 믿기지 않을 만큼 2023년은 정말 빠르게 지나간 것 같습니다. 멋사에서 멋지고 훌륭한 부원들과 함께 활동하며 스스로의 부족함을 객관적으로 돌아볼 수 있었고, 성장에 많은 도움이 되는 좋은 자극들을 받았습니다. 올 한 해를 돌이켜보면, 세션, 스터디, 해커톤 등 다양한 활동들으로 인해 바쁜 시간을 보냈지만, 그 안에서 얻어가는 경험과 성취감은 정말 크고 알찼다고 말할 수 있습니다. 부족한 저를 많이 도와주고 이끌어준 백엔드 팀원들과 운영진분들, 그리고 탄탄하고 멋진 기획으로 좋은 프로젝트, 협업, 소통을 경험할 수 있게 해준 기획디자인 팀과 프론트엔드 팀에게 진심으로 감사의 말씀을 전합니다! 멋사의 한 일원으로 함께할 수 있어서 영광이었습니다. 앞으로의 여정에서도 이 소중한 경험을 바탕으로 더 큰 성장을 이루어나가고 싶습니다. 11기 부원들 모두가 앞으로 나아갈 길을 항상 응원하겠습니다! 덕분에 정말 행복했습니다! 감사합니다:)`,
		},
		{
			id: 7,
			name: "허채린",
			major: "컴공·21",
			content: `멋쟁이사자처럼 활동은 지금까지 저의 대학생활에서 큰 전환점이 되었습니다. 기존에 웹 개발에 대해 막연하게만 흥미만을 가지고 있었고, 혼자서는 무엇부터 공부해야할지, 무엇을 할수있는지 막막해하던 시절에 멋쟁이사자처럼에 들어와 세션을 통해 장고에 대해 배우고, 해커톤 3개를 해치운 방학을 지나오고 여러 프로젝트를 하며 실력도 많이 키우고 스스로에 대한 자신감도 얻을 수 있었습니다. 열정적인 사람들이 모여 생산적이면서도 즐거운, 행복한 시간 보낼 수 있었고 좋은 추억 많이 쌓을 수 있었습니다. 어른사자 아기사자 모두 너무 고마웠고 사랑해요~..~`,
		},
	],
	[
		{
			id: 1,
			name: "이서진",
			major: "컴공·21",
			role: "대표",
			content: `이대 멋사 11기의 활동 후기를 쓰는 날이 오다니.. 지난 2년간 함께한 멋사라는 이름과 이제 정말 이별하는 순간이 왔다는 게 무척 싱숭생숭하네요. 프론트엔드 개발자이자 운영진으로서, 또 11기를 책임졌던 대표로서 많은 시간과 마음을 썼고 그만큼 저라는 사람이 성장했다고 느낍니다.
			
			무엇 하나 확신할 수 없던 때 덜컥 대표라는 역할을 맡아 아직 이름도 얼굴도 몰랐던 아기사자들을 생각하며 열심히 준비했던 기간을 지나, 마침내 우리 11기 여러분을 만났을 때 정말 기뻤습니다🫶
			각자의 목표와 열정을 가진 채 기대를 안고 멋사에 지원해주신 분들을 위해, 언제나 이곳을 선택해준 여러분께 실망은 적고 만족은 큰 시간이 될 수 있도록 노력했는데.. 누구보다 멋사를 사랑해주고 열심히 참여해주신 아기사자들 덕분에 끝까지 함께할 수 있었습니다. 부족한 운영이었을 텐데도 항상 눈을 반짝반짝 빛내며 별것 아닌 저희를 따라와주셔서 감사합니다🙇 OT 때 말씀드렸던 것처럼 올해의 주인공은 누가 뭐래도 여러분이었습니다!
			
            또 10기부터 함께했던 운영진 친구들 언제나 고마웠습니다. 대표를 하겠다고 마음먹은 것도 해낼 수 있었던 것도 전부 운영진들 덕분이었답니다,, 이제는 세션 핑계로 당연하게 만날 수 없다는 게 가장 아쉽네요🥹 (그래도 계속 영원히 함께해••)
			활동은 끝났지만 오래도록 행운 같은 소중한 인연 이어나가며 어디서든 건강하게 지내다가 또 만났으면 좋겠습니다☘️ 앞으로도 이대 멋사 11기 모두와 12기도 응원하겠습니다!! 모두 고마워요👋`,
		},
		{
			id: 2,
			name: "허윤",
			major: "커미·21",
			role: "기획디자인 파트장",
			content: `우하하... 11기 기획디자인 파트장으로 활동했던 허윤입니다 🤓 우선 11기 아기사자 여러분 그동안 모두 수고 많았고 감사했습니다! 이대 멋사에서의 1년이 여러분께 값진 시간으로 기억될 수 있다면 저는 더 바랄 게 없을 것 같습니다.

			또, 많이 부족한 제가 혼자 기디 파트장을 맡게 되어 미흡한 점들이 많았을 텐데도 불구하고 항상 '엄마 사자'라고 불러주며 믿고 따라줬던 기디 아기사자 여러분께 특히 감사의 마음을 전하고 싶습니다.
			맏언니로서 항상 힘이 되어주고 멋지게 취뽀까지 성공한 수민언니🌸, 기디짱 역할을 자처해서 언제나 마음 써준 마더채레사 채원언니🌼, 경영 도메인에 대한 지식으로 새로운 인사이트를 제시해준 예원언니🌿, 미감 못지않은 리액션 부자로서 함께 있기만 해도 행복하게 해준 시은언니🌹, 누구보다 진심으로 활동에 임해줘서 모두의 귀감이 되어준 지민언니🍀, 쿨하게 척척 성장해나가는 모습에 더해 막냉이 역할까지 해준 지형이🌱까지.
			여러분의 귀한 1년을 내어주셔서 감사합니다... 저도 덕분에 후회없는 1년을 보낼 수 있었습니다🙇‍♀️ 머지않아 모두 원하는 바를 이루고 더욱 멋진 사람들이 되어 있을 거라고 믿어 의심치 않습니다. (저도 명색이 파트장이니... 누가 되지 않도록 열심히 노력하겠습니다... 헤헷...)
			
			마지막으로 우리 운영진들 2년이라는 짧지 않은 시간 동안 너무 수고 많았다는 말 해주고 싶습니다...🥹 여러분의 수고를 제가 알고... 함께라 든든했어요. 오래 봅시다!`,
		},
		{
			id: 3,
			name: "정연주",
			major: "사보·20",
			role: "프론트엔드 파트장",
			content: `멋사를 너무 좋아해서 1년 더 활동하게 되었는데, 멋진 아기사자들을 만나서 즐거웠던 2023년입니다! 많이 힘들고 일정이 촉박함에도 불구하고 척척 해내는 아기사자들을 보며 저도 많은 자극을 받았어요. (특히 프엔친구들😁) 너무너무 멋있고 대견합니다.ㅎㅎ 운영진은 처음이라 부족한 점이 많았지만, 그럼에도 믿고 따라준 11기에게 너무 고마워요! 다들 고생 많았습니다. 11기 아기사자들의 성공적인 졸업을 축하합니다. 😆🧡 끝으로 함께 멋사를 이끌어준 운영진과 특히 우리 대표님! 정말 고생하셨습니다. 다들 좋아합니다 ^_^🦁`,
		},
		{
			id: 4,
			name: "이채원",
			major: "뇌인지·21",
			role: "프론트엔드 운영진",
			content: `1년동안 정말정말 !!!! 열심히해준 우리 11기 모두모두 감사하고 사랑합니다 .. 🥹
			특히나 프론트엔드 운영진이자 대표님 서진이, 파트장 연주언니 고생많았습니다. 혼자 기획디자인 운영진 너무나도 잘해준 우리 윤이 그리고 가장 많은 아기사자를 보유한 백엔드 파트장 채영이 유미, 나경이 모두에게 박수 보냅니다 👏👏👏
			부족한 운영진을 잘 따라와주고 무럭무럭 성장한 우리 아기사자들 !! 늘 고맙고 .. 감사했고 … 함께 성장할 수 있어 영광이었습니다 !!! 특히나 프론트엔드 아기사자 다빈 언니, 서연, 지원, 가영, 지혜, 규빈 과제도 많고 힘든 프론트엔드에서 끝까지 열심히해주어 너무 고맙습니다. 함께한 시간들은 좋은 추억으로 평생 간직할게요. 🍀`,
		},
		{
			id: 5,
			name: "임채영",
			major: "컴공·21",
			role: "백엔드 파트장",
			content: `2022년에 10기 아기사자로 활동하면서 백엔드 분야에 처음 입문하게 되었었는데요, 2023년에는 11기 백엔드 운영진으로 활동하면서 작년보다 더 많은 것들을 얻어간것 같아요!!
			어쩌다보니 대학교 4년 중에 2년을 멋사에서 보내게 되었는데 덕분에 열정 넘치고 성실한 사람들을 많이 만나서 성장할수 있었어요🥹🥹
			!!서진이 윤이 연주언니 채원이 유미 나경이!! 전부 1년동안 너무 수고많았고 1년이라는 긴 시간동안 항상 열심히 잘 따라와준 우리 11기 아기사자들 (특히 백엔드 아기사자들ㅎㅎ)에게 고맙고 수고했다는말을 전하고 싶어요~! ❤️
			내년에도 이대멋사 화이팅입니당🦁💚`,
		},
		{
			id: 6,
			name: "이나경",
			major: "휴기바·22",
			role: "백엔드 운영진",
			content: `작년에 가장 잘했다고 생각한 일이 멋쟁이사자처럼에 들어온 일이었는데, 올해도 역시 너무나도 탁월한 선택이었습니다. 입학 때부터 함께해서 이대에 가진 소속감 만큼 이대 멋사에 가진 소속감도 굉장히 컸는데 이제 끝이라니 믿기지가 않네요🥹🥹 어느 곳 보다도 멋있는 사람들을 많이 만날 수 있는 곳이었어요. (매년 많은 해커톤도, 다양한 프로젝트도 멋사의 정말 큰 장점이지만 멋사에서 만든 인연들은 어디서도 만들 수 없다는걸 모두가 알아야 해,,,) 모르는게 많은데도 함께하며 성장하게 도와준 운영진 언니들과 함께 배워가는 입장인데도 세션 열심히 들어준 아기사자들 모두 즐거운 추억 만들어줘서 감사함니다❣️ 작년에는 개발의 첫걸음을 가장 즐겁게 시작해 개발로 빠져들 수 있는 기회를 만들어줘서, 올해는 아는걸 나누면서 한층 더 성장할 수 있게 해줘서 너무나 값진 경험이었습니다. 문득, 자주, 멋사가 아니였다면 웹 개발에 입문하기나 했었을까, 라는 생각을 하고는 해요. 11기 잊지 mot hae...❤️❤️❤️ 걸어봐 위엄 like a lion~🦁`,
		},
		{
			id: 7,
			name: "최유미",
			major: "컴공·21",
			role: "백엔드 운영진",
			content: `운영진으로 활동하면서 이전 부원으로 활동했던 만큼 많은 경험을 얻게 된 것 같습니다!
			다들 너무 열심히 하고, 그만큼 실력도 너무 좋아서 최대한 열심히 도와주려고 했는 데 도움이 됐을지는 모르겠네요... 그래도 옆에서 다양한 아이디어를 지켜보고, 개발하는 과정을 지켜보는 것도 정말 즐겁고 저도 같이 성장하는 기분이었습니다ㅎㅎ
			1년 동안 멋사 활동으로 많은 것을 얻어 갔고, 앞으로 무엇을 하든지 잘되기를 바라겠습니다!
			멋사 11기 파이팅~수고했습니다🤗`,
		},
	],
];
